import React, { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import { useForm } from 'react-hook-form'
import { Button } from '@olxbr/ds-core'
import { Radio } from '@olxbr/ds-web'
import { breakpoints } from '../../../util/medias'
import PropTypes from 'prop-types'
import { updateLegalDocument } from '../../../api/updateLegalDocument'
import { ErrorAlertbox } from '../../atoms/ErrorAlertbox/ErrorAlertbox'
import { RevalidationContext } from '../../../util/providers/RevalidationProvider'
import { CnpjInput } from '../CnpjInput'
import { CpfInput } from '../CpfInput'

const ErrorAlertboxWrapper = styled.div`
  display: flex;
  & div {
    width: 100%;
  }
`
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 308px;
  width: 100%;
`
const WrapperInputRadio = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: var(--spacing-2);

  @media (min-width: ${breakpoints['mobile']}px) {
    margin-bottom: var(--spacing-3);
  }
`
const Form = styled.form`
  display: flex;
  flex-direction: column;
`

const SaveButton = styled(Button).attrs({ variant: 'tertiary', size: 'small' })`
  align-self: flex-end;
  margin-top: var(--spacing-2);
`

export const CpfCnpjUpdate = ({ onSuccessDocument, isLoadingDocument }) => {
  const { legalDocument, token, lurker } = useContext(RevalidationContext)

  const [isCpfAccount, setIsCpfAccount] = useState(true)
  const [isLoading, setIsLoading] = useState(false)
  const [showError, setError] = useState(false)

  const { control, handleSubmit, formState, clearErrors, reset } = useForm({
    reValidateMode: 'onBlur',
    mode: 'onBlur',
    defaultValues: { cpf: '', cnpj: '' },
  })

  const setDefaultValues = () => {
    const isCpf = legalDocument.type === 'cpf'

    setIsCpfAccount(isCpf)
  }

  useEffect(() => {
    legalDocument && legalDocument.type && setDefaultValues()
  }, [legalDocument])

  const handleClickInputRadio = e => {
    reset({ cpf: '', cnpj: '' })
    setIsCpfAccount(e.target.name === 'cpf')
  }

  const onSubmit = async value => {
    const typeDocument = isCpfAccount ? 'cpf' : 'cnpj'
    const maskedValue = value[typeDocument]
    const notFormatedDocument = maskedValue?.replace(/[^0-9]/g, '')

    lurker.clickEvt('save_document', { document_type: typeDocument })

    setIsLoading(true)
    setError(false)

    await updateLegalDocument(token, typeDocument, notFormatedDocument)
      .then(() => {
        lurker.viewMessageEvt('save_document_success', { document_type: typeDocument })
        onSuccessDocument()
      })
      .catch(error => {
        const { response: { status, data: { message } = {} } = {} } = error

        lurker.viewMessageEvt('save_document_error', {
          document_type: typeDocument,
          accounts_reason: message,
          accounts_status_code: status,
        })

        setError(true)
      })
      .finally(setIsLoading(false))
  }

  return (
    <Wrapper>
      {showError && (
        <ErrorAlertboxWrapper>
          <ErrorAlertbox>
            Não foi possível atualizar seu documento. Por favor, tente novamente.
          </ErrorAlertbox>
        </ErrorAlertboxWrapper>
      )}

      <WrapperInputRadio>
        <Radio
          label="Pessoa Física"
          name="cpf"
          onClick={handleClickInputRadio}
          checked={isCpfAccount}
        />
        <Radio
          label="Pessoa Jurídica"
          name="cnpj"
          onClick={handleClickInputRadio}
          checked={!isCpfAccount}
        />
      </WrapperInputRadio>

      <Form>
        {isCpfAccount ? (
          <CpfInput
            type={legalDocument.type}
            value={legalDocument.value}
            control={control}
            reset={reset}
            clearErrors={clearErrors}
            isLoadingDocument={!legalDocument.value && isLoadingDocument}
          />
        ) : (
          <CnpjInput
            type={legalDocument.type}
            value={legalDocument.value}
            control={control}
            reset={reset}
            clearErrors={clearErrors}
            isLoadingDocument={!legalDocument.value && isLoadingDocument}
          />
        )}

        <SaveButton
          type="button"
          onClick={handleSubmit(onSubmit)}
          disabled={!formState.isValid}
          isLoading={isLoading}
        >
          Salvar
        </SaveButton>
      </Form>
    </Wrapper>
  )
}

CpfCnpjUpdate.propTypes = {
  onSuccessDocument: PropTypes.func,
  isLoadingDocument: PropTypes.bool,
}
